import { createFileRoute } from "@tanstack/react-router";
import { UsersPage } from "../../pages/dashboard/users/Users.page";

export const Route = createFileRoute("/_protected/dashboard/users")({
  component: UsersPage,
});
